import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store'
import { i18n } from './translations/i18nSetup'
import '@/scss/app.scss'
import '@/css/common.css'
import firebase from 'firebase'


// import VueAnalytics from 'vue-analytics'
// //and then use it in main.js
// Vue.use(VueAnalytics, {
//     id: 'samsung-star-7bdbe',
//     router
// })

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(VueMaterial)


//import '../node_modules/nprogress/nprogress.css'
// Validate 
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
VeeValidate.Validator.extend('verify_password', {
    validate: value => {
        var strongRegex = new RegExp('^.*(?=.{8,20})(?=.*[0-9])(?=.*[a-zA-Z]).*$')
        return strongRegex.test(value)
    },
})

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

import format from 'vue-format'
Vue.use(format)

import VueMathjax from 'vue-mathjax'
Vue.use(VueMathjax)

import Moment from 'moment'
Moment.locale(localStorage.getItem('languageInfo') ? JSON.parse(localStorage.getItem('languageInfo')).code : 'en')
Vue.prototype.$moment = Moment

import VueLodash from 'vue-lodash'
Vue.use(VueLodash, { name: 'lodash' })

import CircularCountDownTimer from "vue-circular-count-down-timer"
Vue.use(CircularCountDownTimer);

// Filter / Component Define
// import timeFormat from './filters/timeFormat'
// Vue.filter('time', timeFormat)
// import dateYYMMDD from './filters/dateYYMMDD'
// Vue.filter('dateYYMMDD', dateYYMMDD)
import RangeSlider from 'vue-range-slider'
Vue.component('range-slider', RangeSlider);

import PinchZoom from 'vue-pinch-zoom';
Vue.component('pinch-zoom', PinchZoom);

// Plugins Define
import AlertModal from './plugins/alertModal.js'
Vue.use(AlertModal)
import SnackBar from './plugins/snackBar.js'
Vue.use(SnackBar)
import CommonPlugin from './plugins/common.js'
Vue.use(CommonPlugin)
import LoadingPlugin from './plugins/loading.js'
Vue.use(LoadingPlugin)

Vue.config.productionTip = false

/*
// Set Google analytics
import VueAnalytics from 'vue-analytics'
const isProd = true
Vue.use(VueAnalytics, {
    id: 'UA-140414059-1',
    router,
    autoTracking: {
        exception: true
    },
    debug: {
        enabled: !isProd,
        sendHitTask: isProd,
    }
})
*/

// vConsole - stage 및 production 서버에서는 반영되지 않게 하기 위한 조건 처리
import VConsole from 'vconsole';
if (process.env.VUE_APP_PHASE !== "PROD") {
    new VConsole();
}

// Sentry 적용
import * as Sentry from '@sentry/vue';
import { captureScriptError } from "@/utils/sentryScriptHandler.js"

console.log(process.env.VUE_APP_SENTRY_PHASE)
Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    // 센트리 전역 captureException 전송 방지 설정 (해당 설정이 있어야 특정 조건에서만 captureException 적용)
    integrations: [], // 자동 통합 비활성화
    defaultIntegrations: false, // 기본 통합 제거
    tracesSampleRate: 0.0,
    environment: process.env.VUE_APP_SENTRY_PHASE,
});

// 전역 스크립트 오류 핸들러 설정 (Vue 2 전용 설정)
captureScriptError(Vue, "monitoring");

Vue.directive("lowercase", {
    update: function (el) {
        el.value = el.value.toLowerCase();
    }
})

new Vue({
    router,
    created() {
        firebase.initializeApp({
            apiKey: "AIzaSyB3xcrCVfTeRfq0N00ZcBD32xoTUny-RfY",
            authDomain: "clp-rnd.firebaseapp.com",
            databaseURL: "https://clp-rnd.firebaseio.com",
            projectId: "clp-rnd",
            storageBucket: "clp-rnd.appspot.com",
            messagingSenderId: "108449173147",
            appId: "1:108449173147:web:9ab70a7a3e7462fb"
        })
    },
    mounted() { },
    methods: {},
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

